import globalStore from '@/store/global';
import { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { request } from '@src/common';
import { HelpOther, HelperCore } from '@/common/helper';
import ModelManagementPrivateConfirm from '@/components/modal/modal-management/confirm';
import { Input, Select, Divider } from 'antd';
import { SVGPureIcon } from '@/ui';
import store, { TAB_MODEL_TYPE_MAP } from '../store'
import client from '@/store/client';

const DropdownDom = (menu) => {
  return (
    <>
      <p className='text-14px font-bold px-8px py-13px mb-0px'>选择模型</p>
      {menu}
    </>
  )
}

const PrivateConfirm = observer(({ isEdit, item }) => {
  const [firmName, setFirmName] = useState('');
  const [optionList, setOptionList] = useState([]);
  const [agreementType, setAgreementType] = useState(1);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const createFirm = () => {
    if (!firmName) {
      HelpOther.toast('请输入厂商名称', 'info');
      return;
    }
    const params = {
      name: firmName,
      protocol: agreementType,
      model_type: TAB_MODEL_TYPE_MAP[store?.fromTab] || 3,
    }
    if (isEdit) {
      request.post('/user/firm/custom/edit', {
        ...params,
        firm_id: item.id,
      }, {
        dataIsJson: true,
      }).then(res => {
        if (res.code === 0) {
          ModelManagementPrivateConfirm.close();
          store.setPrivateModel({
            ...item,
            name: firmName,
            protocol: agreementType,
          })
          return
        }
        HelpOther.toast('修改失败', 'error');
      }).catch(err => {
        HelpOther.toast('修改失败', 'error');
      })
      return
    }
    request.post('/user/firm/custom', params, {
      dataIsJson: true,
    }).then(res => {
      if (res.code === 0) {
        ModelManagementPrivateConfirm.close();
        store.setPrivateModel({
          name: firmName,
          protocol: agreementType,
          id: res.data.firm_id,
          model_type: TAB_MODEL_TYPE_MAP[store?.fromTab] || 3,
        })
        return
      }
      HelpOther.toast('添加失败', 'error');
    }).catch(err => {
      HelpOther.toast('添加失败', 'error');
    })
  }

  useEffect(() => {
    // 编辑进入
    if (isEdit) {
      setFirmName(item.name);
      setAgreementType(item.protocol || 1);
    }
    let list = [
      { value: 1, label: 'OpenAI兼容协议' },
    ];
    if (client.versionGt('1.3.1068.63') || (HelperCore.isMac() && client.versionGt("1.3.1036.63"))) {
      list = [
        { value: 1, label: 'OpenAI兼容协议' },
        { value: 2, label: 'Gemini兼容协议' },
        { value: 3, label: 'Anthropic兼容协议' },
        { value: 4, label: 'Azure OpenAI兼容协议' },
      ];
    }
    setOptionList(list);
  }, []);

  return (
    <div className='private-confirm w-448px'>
      <div className='flex flex-col'>
        <p className='text-24px mt-12px mb-0px leading-28px font-bold'>添加模型</p>
        <Divider className={globalStore.isDark ? 'dark-divider' : ''} />
        <p className='text-14px font-bold'>提供商名称</p>
        <Input className='h-40px' maxLength={200} value={firmName} onChange={(event) => setFirmName(event.target.value)} allowClear placeholder="例如 “公司部署的大模型”" />
        <p className='mt-32px text-14px font-bold'>提供商类型</p>
        <Select
          className='h-40px'
          value={agreementType}
          popupClassName="custom-select-dropdown"
          onChange={(val) => setAgreementType(val)}
          options={optionList}
          dropdownRender={DropdownDom}
          suffixIcon={
            <span className={`transition-transform duration-300}`} style={{
              rotate: dropdownOpen ? '180deg' : ''
            }}>
              <SVGPureIcon className='size-12px text-[#000]/50' name="arrow_competitive"></SVGPureIcon>
            </span>
          }
          onDropdownVisibleChange={(open) => setDropdownOpen(open)}
        />
        <div className='mt-24px flex justify-end gap-12px'>
          <div
            className='w-96px h-40px flex items-center justify-center bg-[rgba(0,0,0,0.06)] rounded-10px cursor-pointer'
            onClick={() => ModelManagementPrivateConfirm.close()}>
            取消
          </div>
          <div
            className={`w-96px h-40px flex items-center justify-center rounded-10px
                    cursor-pointer ${!firmName ? 'bg-[rgba(0,0,0,0.06)] text-[rgba(0,0,0,0.3)]' : 'bg-[#000000] text-[#ffffff]'}`}
            onClick={createFirm}
          >
            确定
          </div>
        </div>
      </div>
    </div>
  );
});
export default PrivateConfirm;
